import SearchMenu from './search-menu';
export default SearchMenu;